import { render, staticRenderFns } from "./AssociatedRealNameActivity.vue?vue&type=template&id=9cb45668&scoped=true&"
import script from "./AssociatedRealNameActivity.vue?vue&type=script&lang=js&"
export * from "./AssociatedRealNameActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb45668",
  null
  
)

export default component.exports